export const getOriginalContent = ({ ugc }) => {
    const { ugcMap } = ugc;

    return ugcMap.original;
};
